import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { RouterLink } from '@angular/router';
import { Button, LinkComponent } from '@teamfoster/sdk/button';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { CollectionCardComponent } from 'src/app/museum-collections/components';
import { MuseumCollection } from 'src/app/museum-collections/models';

@Component({
  selector: 'app-content-block-cta-image-cards',
  standalone: true,
  imports: [ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe, CollectionCardComponent, RouterLink, LinkComponent, IconComponent],
  templateUrl: './content-block-cta-image-cards.component.html',
  styleUrl: './content-block-cta-image-cards.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockCtaImageCardsComponent extends ContentBlockBaseComponent {
  cards: Signal<{ collection: Partial<MuseumCollection>; url: string | undefined; button: Button; intro: string | null }[]> = computed(
    () => {
      return (
        this.block()?.ctaItems?.map(item => {
          return {
            collection: {
              id: item.id,
              title: item.title,
              text: item.text,
              image: item.image || null,
              url: item.button?.routerLink || undefined,
            },
            url: item.button?.url || undefined,
            intro: item.text,
            button: item.button,
          };
        }) ?? []
      );
    }
  );
}
